import React from 'react';
import FooterCell from './FooterCell';
import { createUniqueKey } from '../../../utils';
import { Column } from '../utils/types';

export type TFooter = {
  [key: string]: string | number | ((...args: any[]) => any);
};

export type TFooterProps = {
    columns: Column[];
    footer: TFooter | undefined;
};

function Footer(props: TFooterProps) {
    const { columns = [], footer = null } = props;

    if (!footer) return null;

    return (
        <tfoot>
            <tr role="row">
                {columns?.map((column, index) => (
                    <FooterCell
                        column={column}
                        data={footer}
                        item={footer[column.key]}
                        key={createUniqueKey(index, column)}
                    />
                ))}
            </tr>
        </tfoot>
    );
}

export default Footer;
